import * as t from "./actionType";

// ---------- REPORT ----------
export const serpReportList = (data) => ({ type: t.SERP_REPORT_LIST, data });
export const serpReportListSuccess = (data) => ({ type: t.SERP_REPORT_LIST_SUCCESS, data });
export const serpReportListFail = (data) => ({ type: t.SERP_REPORT_LIST_FAIL, data });

export const serpReportData = (data) => ({ type: t.SERP_REPORT_DATA, data });
export const serpReportDataSuccess = (data) => ({ type: t.SERP_REPORT_DATA_SUCCESS, data });
export const serpReportDataFail = (data) => ({ type: t.SERP_REPORT_DATA_FAIL, data });

export const serpReportCreate = (data) => ({ type: t.SERP_REPORT_CREATE, data });
export const serpReportCreateSuccess = (data) => ({ type: t.SERP_REPORT_CREATE_SUCCESS, data });
export const serpReportCreateFail = (data) => ({ type: t.SERP_REPORT_CREATE_FAIL, data });
export const serpReportCreateReset = () => ({ type: t.SERP_REPORT_CREATE_RESET });

export const serpReportUpdate = (data) => ({ type: t.SERP_REPORT_UPDATE, data });
export const serpReportUpdateSuccess = (data) => ({ type: t.SERP_REPORT_UPDATE_SUCCESS, data });
export const serpReportUpdateFail = (data) => ({ type: t.SERP_REPORT_UPDATE_FAIL, data });
export const serpReportUpdateReset = () => ({ type: t.SERP_REPORT_UPDATE_RESET });

export const serpReportDelete = (data) => ({ type: t.SERP_REPORT_DELETE, data });
export const serpReportDeleteSuccess = (data) => ({ type: t.SERP_REPORT_DELETE_SUCCESS, data });
export const serpReportDeleteFail = (data) => ({ type: t.SERP_REPORT_DELETE_FAIL, data });
export const serpReportDeleteReset = () => ({ type: t.SERP_REPORT_DELETE_RESET });

export const serpReportRun = (id) => ({ type: t.SERP_REPORT_RUN, data: id });
export const serpReportRunSuccess = (data) => ({ type: t.SERP_REPORT_RUN_SUCCESS, data });
export const serpReportRunFail = (data) => ({ type: t.SERP_REPORT_RUN_FAIL, data });
export const serpReportRunReset = () => ({ type: t.SERP_REPORT_RUN_RESET });

export const serpReportPdf = (data) => ({ type: t.SERP_REPORT_PDF, data });
export const serpReportPdfSuccess = (data) => ({ type: t.SERP_REPORT_PDF_SUCCESS, data });
export const serpReportPdfFail = (data) => ({ type: t.SERP_REPORT_PDF_FAIL, data });
export const serpReportPdfReset = () => ({ type: t.SERP_REPORT_PDF_RESET });

export const serpReportSnapshotPdf = (id) => ({ type: t.SERP_REPORT_SNAPSHOT_PDF, data: id });
export const serpReportSnapshotPdfSuccess = (data) => ({ type: t.SERP_REPORT_SNAPSHOT_PDF_SUCCESS, data });
export const serpReportSnapshotPdfFail = (data) => ({ type: t.SERP_REPORT_SNAPSHOT_PDF_FAIL, data });
export const serpReportSnapshotPdfReset = () => ({ type: t.SERP_REPORT_SNAPSHOT_PDF_RESET });

export const serpReportEmail = (data) => ({ type: t.SERP_REPORT_EMAIL, data });
export const serpReportEmailSuccess = (data) => ({ type: t.SERP_REPORT_EMAIL_SUCCESS, data });
export const serpReportEmailFail = (data) => ({ type: t.SERP_REPORT_EMAIL_FAIL, data });
export const serpReportEmailReset = () => ({ type: t.SERP_REPORT_EMAIL_RESET });

// ---------- ITEM (keyword) ----------
export const serpItemList = (data) => ({ type: t.SERP_ITEM_LIST, data });
export const serpItemListSuccess = (data) => ({ type: t.SERP_ITEM_LIST_SUCCESS, data });
export const serpItemListFail = (data) => ({ type: t.SERP_ITEM_LIST_FAIL, data });

export const serpItemData = (data) => ({ type: t.SERP_ITEM_DATA, data });
export const serpItemDataSuccess = (data) => ({ type: t.SERP_ITEM_DATA_SUCCESS, data });
export const serpItemDataFail = (data) => ({ type: t.SERP_ITEM_DATA_FAIL, data });

export const serpItemCreate = (data) => ({ type: t.SERP_ITEM_CREATE, data });
export const serpItemCreateSuccess = (data) => ({ type: t.SERP_ITEM_CREATE_SUCCESS, data });
export const serpItemCreateFail = (data) => ({ type: t.SERP_ITEM_CREATE_FAIL, data });
export const serpItemCreateReset = () => ({ type: t.SERP_ITEM_CREATE_RESET });

export const serpItemUpdate = (data) => ({ type: t.SERP_ITEM_UPDATE, data });
export const serpItemUpdateSuccess = (data) => ({ type: t.SERP_ITEM_UPDATE_SUCCESS, data });
export const serpItemUpdateFail = (data) => ({ type: t.SERP_ITEM_UPDATE_FAIL, data });
export const serpItemUpdateReset = () => ({ type: t.SERP_ITEM_UPDATE_RESET });

export const serpItemDelete = (data) => ({ type: t.SERP_ITEM_DELETE, data });
export const serpItemDeleteSuccess = (data) => ({ type: t.SERP_ITEM_DELETE_SUCCESS, data });
export const serpItemDeleteFail = (data) => ({ type: t.SERP_ITEM_DELETE_FAIL, data });
export const serpItemDeleteReset = () => ({ type: t.SERP_ITEM_DELETE_RESET });

// ---------- SNAPSHOT ----------
export const serpSnapshotList = (data) => ({ type: t.SERP_SNAPSHOT_LIST, data });
export const serpSnapshotListSuccess = (data) => ({ type: t.SERP_SNAPSHOT_LIST_SUCCESS, data });
export const serpSnapshotListFail = (data) => ({ type: t.SERP_SNAPSHOT_LIST_FAIL, data });

export const serpSnapshotData = (data) => ({ type: t.SERP_SNAPSHOT_DATA, data });
export const serpSnapshotDataSuccess = (data) => ({ type: t.SERP_SNAPSHOT_DATA_SUCCESS, data });
export const serpSnapshotDataFail = (data) => ({ type: t.SERP_SNAPSHOT_DATA_FAIL, data });

export const serpSnapshotDelete = (data) => ({ type: t.SERP_SNAPSHOT_DELETE, data });
export const serpSnapshotDeleteSuccess = (data) => ({ type: t.SERP_SNAPSHOT_DELETE_SUCCESS, data });
export const serpSnapshotDeleteFail = (data) => ({ type: t.SERP_SNAPSHOT_DELETE_FAIL, data });
export const serpSnapshotDeleteReset = () => ({ type: t.SERP_SNAPSHOT_DELETE_RESET });

// ---------- RESULT (position) ----------
export const serpResultBySnapshot = (data) => ({ type: t.SERP_RESULT_BY_SNAPSHOT, data });
export const serpResultBySnapshotSuccess = (data) => ({ type: t.SERP_RESULT_BY_SNAPSHOT_SUCCESS, data });
export const serpResultBySnapshotFail = (data) => ({ type: t.SERP_RESULT_BY_SNAPSHOT_FAIL, data });

export const serpResultByItem = (data) => ({ type: t.SERP_RESULT_BY_ITEM, data });
export const serpResultByItemSuccess = (data) => ({ type: t.SERP_RESULT_BY_ITEM_SUCCESS, data });
export const serpResultByItemFail = (data) => ({ type: t.SERP_RESULT_BY_ITEM_FAIL, data });

export const serpResultData = (data) => ({ type: t.SERP_RESULT_DATA, data });
export const serpResultDataSuccess = (data) => ({ type: t.SERP_RESULT_DATA_SUCCESS, data });
export const serpResultDataFail = (data) => ({ type: t.SERP_RESULT_DATA_FAIL, data });

// id = SerpReportSearchItemResult_Id → full organic listing (competitors)
export const serpResultOrganic = (id) => ({ type: t.SERP_RESULT_ORGANIC, data: id });
export const serpResultOrganicSuccess = (data) => ({ type: t.SERP_RESULT_ORGANIC_SUCCESS, data });
export const serpResultOrganicFail = (data) => ({ type: t.SERP_RESULT_ORGANIC_FAIL, data });
export const serpResultOrganicReset = () => ({ type: t.SERP_RESULT_ORGANIC_RESET });
